"use client";

import { HistoricalEventData } from "@/lib/hygraph";
import { CldImage } from "next-cloudinary";

interface HistoricalEventCardProps {
  event: HistoricalEventData;
}

export default function HistoricalEventCard({
  event,
}: HistoricalEventCardProps) {
  return (
    <article
      className="historical-event-card group absolute flex flex-col md:flex-row-reverse md:data-[side=right]:flex-row items-start gap-4 w-[280px] max-w-[calc(100vw-32px)] md:w-[420px] p-4 md:p-5 pointer-events-auto invisible"
      data-event-id={event.id}
    >
      <div className="event-content flex-1 w-full text-right group-data-[side=right]:text-left">
        <h4 className="date-heading font-headings-uppercase text-2xl md:text-3xl font-bold mb-1 text-hover-purple">
          {event.historicalEventDateHeading}
        </h4>
        <h3 className="event-heading font-cta text-2xl md:text-3xl mb-3 text-white/95 leading-none">
          {event.historicalEventHeading}
        </h3>
        <p className="event-summary font-body text-s md:text-m leading-relaxed text-white/70">
          {event.historicalEventSummary}
        </p>
      </div>
      {event.historicalEventImage && (
        <div className="event-image flex-shrink-0">
          <CldImage
            src={event.historicalEventImage.public_id}
            alt={event.historicalEventHeading}
            width={180}
            height={180}
            className="rounded-lg object-cover w-20 h-20 md:w-[180px] md:h-[180px]"
          />
        </div>
      )}
    </article>
  );
}
